export const ProcessStatus = {
	none: 0,
	running: 1,
	failed: 2,
	done: 5,
	canceled: 6,
}
